import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import moment from 'moment';
import { Utility } from 'src/app/services/utility';
import { IArtworkGenerationSettings, IGlobalSettings } from '../../../../../../../common/common-interfaces/global-settings';
import { availableExaktaSKUs } from '../../../../../../../common/common-third-party/exakta';
import { countryCodes } from '../../../../../../../common/common-types/country';
import { posterSizesByName } from '../../../../../../../common/common-types/poster-size';
import { getBorderModificationCode } from '../../../../../../../common/common-helpers/print-file';

@Component({
    selector: 'admin-settings',
    templateUrl: './admin-settings.component.html',
    styleUrls: ['./admin-settings.component.scss'],
    standalone: false
})
export class AdminSettingsComponent {
  settings: IGlobalSettings;
  availableExaktaSKUs = availableExaktaSKUs;
  availablePosterSizes = Object.keys(posterSizesByName);
  syncingPriceList: boolean = false;
  syncResult: any;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }



  async ngOnInit() {
    this.globals.loadAdminKey();
    this.settings = await this.api.admin().get<any>(`/settings`);

    if (!this.settings.vendors)
      this.settings.vendors = [];

    if (!this.settings.productionCosts)
      this.settings.productionCosts = {
        skus: {}
      }

    // Seeded here so the tab has something to bind to on a settings document
    // saved before artwork generation existed. Mirrors
    // DEFAULT_ARTWORK_GENERATION_SETTINGS on the server.
    let artworkGenerationDefaults: IArtworkGenerationSettings = {
      mode: 'batch',
      model: 'gpt-image-2',
      quality: 'high',
      maxArtworksPerRun: 10,
      maxProductsPerRun: 5,
      synchronousConcurrency: 3
    };

    this.settings.artworkGenerationSettings = Object.assign(artworkGenerationDefaults, this.settings.artworkGenerationSettings || {});

    // Passepartout widths drive the B<width>W code in a Shopify variant SKU.
    if (!this.settings.passepartoutWidths)
      this.settings.passepartoutWidths = {};

    if (!this.settings.productionCosts.countrySpecificShippingCosts)
      this.settings.productionCosts.countrySpecificShippingCosts = {};

    for (let sku of this.availableExaktaSKUs) {
      if (!this.settings.productionCosts.skus[sku]) {
        this.settings.productionCosts.skus[sku] = {
          printCost: 0,
          shippingCost: 0,
          weight: 0
        }
      }


      for (let country of countryCodes) {
        if (!this.settings.productionCosts.countrySpecificShippingCosts[country])
          this.settings.productionCosts.countrySpecificShippingCosts[country] = {};
        if (!this.settings.productionCosts.countrySpecificShippingCosts[country][sku])
          this.settings.productionCosts.countrySpecificShippingCosts[country][sku] = { shippingCost: 0 };
      }
      delete this.settings.productionCosts.countrySpecificShippingCosts['se'];

    }
  }

  /** Preview of the SKU code a configured width produces, e.g. 35 -> B35W. */
  passepartoutCode(size: string) {
    return getBorderModificationCode(this.settings.passepartoutWidths[size]);
  }

  addVendor() {
    this.settings.vendors.push({
      name: '',
      comissionPercent: 0
    });
  }

  removeVendor(vendor) {
    this.settings.vendors.splice(this.settings.vendors.indexOf(vendor), 1);
  }

  async save() {

    // Switch SKU to landscape and set the same price
    for (let sku of this.availableExaktaSKUs) {
      let split = [];

      // Poster
      if (sku.includes('Poster_') && (sku.includes('_obestruket') || sku.includes('_bestruket'))) {
        split = sku.split('_');
      }
      if (split.length) {
        let sizeSplit = split[1].split('x');
        this.settings.productionCosts.skus[`${split[0]}_${sizeSplit[1]}x${sizeSplit[0]}_${split[2]}`] = this.settings.productionCosts.skus[sku];
      }

      split = [];

      // Canvas
      if (sku.includes('Canvas_')) {
        split = sku.split('_');
      }

      if (split.length) {
        let sizeSplit = split[1].split('x');
        this.settings.productionCosts.skus[`${split[0]}_${sizeSplit[1]}x${sizeSplit[0]}`] = this.settings.productionCosts.skus[sku];
      }

    }

    await this.api.admin().put<any>(`/settings`, this.settings);
  }


  async syncPriceList() {
    this.syncingPriceList = true;
    this.syncResult = await this.api.admin().post<any>(`/sync-price-list`, {});
    this.settings = await this.api.admin().get<any>(`/settings`);
    this.syncingPriceList = false;
  }


}
